import { Divider, Flex, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToken } from "../../hooks/useToken";

export function Privacy() {
  const { screens, token } = useToken();
  const navigate = useNavigate();
  const [privacy, setPrivacy] = useState<{ topic: string; text: string[] }[]>([]);

  useEffect(() => {
    fetch("/privacy.json")
      .then((data) => data.json())
      .then((data) => {
        setPrivacy(data);
      })
      .catch(() => {});
  }, []);

  return (
    <>
      <Flex
        style={{
          backgroundColor: "rgba(0,0,0,0.5)",
          padding: screens.md
            ? `${token.paddingLG}px ${token.paddingXL}px`
            : `${token.paddingLG}px ${token.padding}px`,
          backdropFilter: "blur(20px)",

          width: "100%",
          position: "sticky",
          top: 0,
          left: 0,
        }}
      >
        <img
          src="/assets/logo_dark.png"
          style={{
            height: "30px",
            objectFit: "contain",
            cursor: "pointer",
          }}
          onClick={() => {
            navigate("/");
          }}
        />
      </Flex>
      <div
        style={{
          marginTop: "-78px",
          backgroundColor: token.colorBgContainer,
          minHeight: "100vh",
          padding: screens.md
            ? `${token.paddingLG + 78}px ${token.paddingXL}px`
            : `${token.paddingLG + 78}px ${token.padding}px`,
        }}
      >
        <Typography
          style={{
            color: token.colorTextHeading,
            fontSize: !screens.md
              ? token.fontSizeHeading3
              : token.fontSizeHeading2,
            fontWeight: token.fontWeightStrong,
          }}
        >
          Privacy and Policy
        </Typography>

        <Divider />

        <div
          style={{
            overflow: "auto",
            maxWidth: "695px",
            margin: "0 auto",
            padding: screens.md
              ? `${token.paddingLG}px ${token.paddingXL}px`
              : `${token.paddingXL}px ${token.padding}px`,
          }}
        >
          {privacy.map((term, index) => {
            return (
              <Flex key={index} vertical>
                <Typography
                  style={{
                    fontSize: token.fontSizeHeading4,
                    color: token.colorTextHeading,
                    fontWeight: token.fontWeightStrong,
                    marginBottom: token.marginXS,
                  }}
                >
                  {term.topic}
                </Typography>
                {term.text.map((desc, index) => {
                  return (
                    <Typography
                      key={index}
                      style={{
                        fontSize: token.fontSize,
                        color: token.colorTextSecondary,
                        marginBottom: token.marginMD,
                      }}
                    >
                      {desc}
                    </Typography>
                  );
                })}
              </Flex>
            );
          })}
        </div>
      </div>
    </>
  );
}
